const Programs = [
  {
    title: 'basico',
    quarters: [
      {
        quarter: 1,
        courses: [
          {
            code: 'GA01-2',
            name: 'Técnicas y Fundamentos Culinarios I'
          },
          {
            code: 'GE10-2',
            name: 'Técnicas Básicas de Panadería'
          },
          {
            code: 'GE01-2',
            name: 'Higiene y Manipulación'
          },
        ],
      },
      {
        quarter: 2,
        courses: [
          {
            code: 'GA02-2',
            name: 'Técnicas y Fundamentos Culinarios II'
          },
          {
            code: 'GA03-2',
            name: 'Técnicas Básicas de Pastelería'
          },
        ]
      },
      // {
      //   quarter: 3,
      //   courses: [
      //     {
      //       code: 'GA04-2',
      //       name: 'Cumplimiento de 300 horas Prácticas'
      //     },
      //   ]
      // },
    ]
  },
  {
    title: 'medio',
    quarters: [
      {
        quarter: 1,
        courses: [  
          {
            code: 'GA01-2',
            name: 'Técnicas y Fundamentos Culinarios I'
          },
          {
            code: 'GE10-2',
            name: 'Técnicas Básicas de Panadería'
          },
          {
            code: 'GE01-2',
            name: 'Control de Costos'
          },
          {
            code: 'MT01-2',
            name: 'Higiene y Manipulación'
          },
          {
            code: 'GA03-2',
            name: 'Técnicas Básicas de Pastelería'
          }
        ]
      },
      {
        quarter: 2,
        courses: [
          {
            code: 'GA01-2',
            name: 'Técnicas y Fundamentos Culinarios II'
          },
          {
            code: 'GE10-2',
            name: 'Cocina Internacional I (Arroces y Pastas)'
          },
          {
            code: 'GE01-2',
            name: 'Garde Manger'
          },
          {
            code: 'MT01-2',
            name: 'Técnicas Básicas de Pastelería'
          }
        ]
      },
      {
        quarter: 3,
        courses: [
          {
            code: 'GA01-2',
            name: 'Cocina Internacional II (Europa)'
          },
          {
            code: 'GE10-2',
            name: 'Cocina Internacional II (Asia)'
          },
          {
            code: 'GE01-2',
            name: 'Garde Manger'
          },
          {
            code: 'MT01-2',
            name: 'Técnicas Básicas de Pastelería'
          },
          {
            code: 'PA04-2',
            name: 'Cocina Contemporánea'
          },
          {
            code: 'CM01-2',
            name: 'Cocina América y Costa Rica'
          }
        ]
      },
      // {
      //   quarter: 4,
      //   courses: [
      //     {
      //       code: 'GA01-2',
      //       name: 'Examen Final de Graduación'
      //     },
      //     {
      //       code: 'GE10-2',
      //       name: 'Cumplimiento de 600 horas Prácticas'
      //     }
      //   ]
      // }
    ]
  },
  {
    title: 'profesional',
    quarters: [
      {
        quarter: 1,
        courses: [
          {
            code: 'GA01-2',
            name: 'Técnicas y Fundamentos Culinarios I'
          },
          {
            code: 'GE10-2',
            name: 'Idioma con Énfasis en Gastronomía'
          },
          {
            code: 'GE01-2',
            name: 'Prevención de Riesgos y Primeros Auxilios'
          },
          {
            code: 'MT01-2',
            name: 'Métodos y Técnicas de Investigación'
          },
          {
            code: 'PA04-2',
            name: 'Técnicas Básicas de Panadería'
          },
          {
           code: 'CM01-2',
            name: 'Higiene y Manipulación' 
          }
        ],
      },
      {
        quarter: 2,
        courses: [
          {
            code: 'GA02-2',
            name: 'Técnicas y Fundamentos Culinarios II'
          },
          {
            code: 'GA03-2',
            name: 'Contol de Costos'
          },
          {
            code: 'GE02-2',
            name: 'Técnicas Básicas de Pastelería'
          },
          {
            code: 'AM01-2',
            name: 'Servicio de Alimentos y Bebida'
          },
          {
            code: 'PA05-2',
            name: 'Productos locales, Gourmet y Especializados'
          }
        ]
      },
      {
        quarter: 3,
        courses: [
          {
            code: 'GA04-2',
            name: 'Cocina de Eventos'
          },
          {
            code: 'GA05-2',
            name: 'Conocimiento de Bebidas'
          },
          {
            code: 'AM02-2',
            name: 'Garde Manger'
          },
          {
            code: 'PA06-2',
            name: 'Fundamentos de la Gestión de Negocios (Adm).'
          },
          {
            code: 'PR01-2',
            name: 'Nutrición y Dietética'
          },
        ]
      },
      {
        quarter: 4,
        courses: [
          {
            code: 'GA04-2',
            name: 'Cocina de América y Costa Rica'
          },
          {
            code: 'GA05-2',
            name: 'Eno Gastronomía'
          },
          {
            code: 'AM02-2',
            name: 'Arte de Comunicar'
          },
          {
            code: 'PA06-2',
            name: 'Gestión del Mercadeo'
          },
          {
            code: 'PR01-2',
            name: 'Contabilidad Gastronómica'
          },
        ]
      },
      {
        quarter: 5,
        courses: [
          {
            code: 'GA04-2',
            name: 'Cocina Internacional I (Arroces y Pastas)'
          },
          {
            code: 'GA05-2',
            name: 'Cocina Internacional II (Europa)'
          },
          {
            code: 'AM02-2',
            name: 'Formulación de Proyectos Gastronómicos'
          },
          {
            code: 'PA06-2',
            name: 'Marca Personal'
          },
          {
            code: 'PR01-2',
            name: 'Artquitectura y Estructura del Menú'
          },
        ]
      },
      {
        quarter: 6,
        courses: [
          {
            code: 'GA04-2',
            name: 'Cocina Internacional III (Asia)'
          },
          {
            code: 'GA05-2',
            name: 'Cocina Contemporánea'
          },
          {
            code: 'AM02-2',
            name: 'Diseño de la Experiencia Gastronómica'
          },
          {
            code: 'PA06-2',
            name: 'Emprendimiento Gastronómico'
          },
          {
            code: 'PR01-2',
            name: 'Control de Calidad en Establecimientos Gastronómicos'
          },
        ]
      },
      // {
      //   quarter: 7,
      //   courses: [
      //     {
      //       code: 'GA04-2',
      //       name: 'Examen Final de Graduación'
      //     },
      //     {
      //       code: 'GA05-2',
      //       name: 'Cumplimiento de 900 horas Prácticas'
      //     }
      //   ]
      // }
    ]
  },
  {
    title: 'panaderia-y-pasteleria',
    quarters: [
      {
        quarter: 1,
        courses: [
          {
            code: 'GA03-2',
            name: 'Técnicas y Fundamentos Culinarios I'
          },
          {
            code: 'GE10-2',
            name: 'Técnicas Básicas de Panadería'
          },
          {
            code: 'GE01-2',
            name: 'Higiene y Manipulación'
          },
        ],
      },
      {
        quarter: 2,
        courses: [
          {
            code: 'PA02-4',
            name: 'Especialidades de Postres'
          },
          {
            code: 'PA02-1',
            name: 'Especialidades de Pastelería'
          },
        ]
      },
      {
        quarter: 3,
        courses: [
          {
            code: 'PA02-3',
            name: 'Especialidades de Repostería'
          },
          {
            code: '	PA02-5',
            name: 'Chocolatería y Helados'
          },
        ]
      },
      {
        quarter: 4,
        courses: [
          {
            code: 'PA10-2',
            name: 'Especialidades de Panadería'
          },
          {
            code: 'PA02-6',
            name: 'Diseño de Queques'
          },
        ]
      },
    ]
  },
  {
    title: 'mixologia',
    quarters: [
      {
        quarter: 1,
        courses: [
          {
            code: 'EM-05',
            name: 'Fundamentos de la Mixología'
          },
        ]
      },
      {
        quarter: 2,
        courses: [
          {
            code: 'EM-06',
            name: 'Mixología de Autor y Coctelería Contemporánea'
          },
        ]
      },
    ]
  },
  {
    title: 'barismo',
    quarters: [
      {
        quarter: 1,
        courses: [
          {
            code: 'BAR-01',
            name: 'Introducción al Barismo'
          },
        ]
      },
      {
        quarter: 2,
        courses: [
          {
            code: 'BAR-02',
            name: 'Control de Calidad'
          },
        ]
      },
      {
        quarter: 3,
        courses: [
          {
            code: 'BAR-03',
            name: 'Bebidas a base de café'
          },
        ]
      },
    ]
  }
]

export default Programs;